import { scan } from 'react-scan';

import ReactDOM from 'react-dom/client';
import './i18n/i18next';
import { StrictMode, Suspense, lazy, useEffect } from 'react';
import { ConfigComponent } from '@sobrus-com/sobrus-design-system-v2';
import ReloadPrompt from './components/ReloadPrompt/ReloadPrompt';
import * as Sentry from '@sentry/react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';
import GlobalTooltip from './helpers/GlobalTooltip';
import { clearStorageOnNewRelease } from './utils/storage';

clearStorageOnNewRelease();

const App = lazy(() => import('./App'));

if (import.meta.env.VITE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://9c02ae3e6eb1f874959647b610b9b1b2@o4505092585816064.ingest.us.sentry.io/4509676884197376',
    environment: import.meta.env.VITE_REACT_APP_ENV,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
      }),
    ],
    ignoreErrors: [/^Unable to preload CSS/],
    denyUrls: [
      /hotjar\.com/,
      /cdn\.jsdelivr\.net/,
      /googletagmanager\.com/i,
      /chrome-extension:\/\//i,
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: import.meta.env.VITE_ENV !== 'development',
  });
}
if (import.meta.env.VITE_ENV === 'development') {
  scan({
    enabled: true,
  });
}

const ContainerApp = () => {
  return (
    <StrictMode>
      <Suspense fallback={null}>
        <ConfigComponent fonts={{ fontFamily: 'Inter' }} solution='pharma'>
          <App />
          <ReloadPrompt />
          <GlobalTooltip />
        </ConfigComponent>
      </Suspense>
    </StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<ContainerApp />);
